import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API, SERVISE_ADDR } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js';
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* login(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }

    let http = new HttpConnection();
    let info = {
        url: URL_API + '/login',
        parameter: {
            address: action.address,
            password: action.password,
            admin: action.admin,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        yield put({
            type: "Login",
            user: data.user,
        })
        if(action.onSuccess) {
            action.onSuccess(data.user);
        }
    } else {
        if(data.statusCode === 400) {
            yield put({
                type: "ErrorInfo",
                source: "login",
                statusCode: data.statusCode,
                error: data.error,
            });
        }
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const loginSaga = takeEvery('Login_Saga', login);

function* loginCheck_(action) {
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/loginCheck',
        parameter: {
            id: action.id,
            token: action.token,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        localStorage.setItem('token', data.body.token);
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        if(action.onFailure) {
            action.onFailure();
        }
    }
}

export const loginCheckSaga = takeEvery('LoginCheck_Saga', loginCheck_);

function* logout(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/logout',
        parameter: {
            token: localStorage.getItem('token')
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if (action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "logout",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const logoutSaga = takeEvery('Logout_Saga', logout);

function* pwReset(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/passwordReset',
        parameter: {
            id: action.id,
            onetime: action.onetime,
            authcode: action.authcode,
            password: action.password,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "passwordReset",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const pwResetSaga = takeEvery('PWReset_Saga', pwReset);

function* pwInit(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/passwordInit',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "passwordInit",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const pwInitSaga = takeEvery('PWInit_Saga', pwInit);

function* pwResetRequest(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/passwordResetReq',
        parameter: {
            to: action.address,
            from: SERVISE_ADDR,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "passwordResetRequest",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const pwResetRequestSaga = takeEvery('PWResetRequest_Saga', pwResetRequest);

function* settingPassword(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/settingPassword',
        parameter: {
            id: action.id,
            password: action.password,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "settingPassword",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const settingPasswordSaga = takeEvery('SettingPassword_Saga', settingPassword);
